---
nb:
  news_items:
    attachment: Vedlegg
    categories:
      findings: Funn
      landowner: Grunneier
      news: Nyheter
      other: Annet
      project: Prosjekt
      report: Rapport
      user_manual: Brukermanual
    community_access: Brukere kan se community innlegg
    community_warning: Community innlegg blir synlig for alle portalens brukere
    create_post: Opprett innlegg
    edit_post: Rediger innlegg
    filter_all: Alle innlegg
    filter_category: Filter kategori
    filter_community: Community innlegg
    filter_internal: Interne innlegg
    filter_power_plant: Filter kraftverk
    flash_delete_error: Kunne ikke slettes
    hydro_power_news: Vannkraftnyheter
    image_positions:
      left: Venstre
      right: Høyre
      top: Topp
    landowner_access_info: Grunneiere i dette selskapet og dets datterselskaper vil kunne se dette innlegget
    latest_posts: Siste innlegg
    markdown_supported: Markdown støttes
    model_name: Innlegg
    portfolio_warning: Datterselskaper vil kunne lese dette innlegget
    publish: Opprett innlegg
    save: Lagre innlegg
    search_placeholder: Søk etter tittel, innhold eller forfatter...
    submit_draft: Lagre som utkast
    subsidiaries_warning: Dette innlegget vil være synlig for alle portefølje- og redaktørbrukere i datterselskaper av de valgte selskapene (grunneier-tilgang krever egen avkrysning)
    unpublished_draft: Du har upubliserte utkast
